import DailyOutputReportPage from "./DailyOutputReportPage";

export default function DailyTLReportPage() {
  return (
    <DailyOutputReportPage
      title="Daily TL Report"
      label="Team Leader"
      endpoint="/reports/daily-tl-output"
      detailEndpoint="/reports/daily-tl-output/details"
      detailParamName="tl_name"
      exportEndpoint="/reports/daily-tl-output/export"
      filterEndpoint="/reports/team-leaders"
      filterLabel="Team Leader"
      filterParamName="team_leaders"
      exportFilenamePrefix="Daily_TL_Report"
    />
  );
}
